import { render, staticRenderFns } from "./DeleteClasses.vue?vue&type=template&id=07285610&scoped=true&"
import script from "./DeleteClasses.vue?vue&type=script&lang=js&"
export * from "./DeleteClasses.vue?vue&type=script&lang=js&"
import style0 from "./DeleteClasses.vue?vue&type=style&index=0&id=07285610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07285610",
  null
  
)

export default component.exports